import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Skeleton } from "@mui/material";
import { palette } from "../../styles/palette";

interface RankingTableSkeletonProps {
  isDesktop?: boolean;
  /** Number of placeholder rows to render while data loads. */
  rows?: number;
}

// Mirrors the column layout of MobileRankingTable so the placeholder lines up
// with the real table and there is no layout shift once data arrives.
const RankingTableSkeleton: React.FC<RankingTableSkeletonProps> = ({
  isDesktop,
  rows = 8,
}) => {
  const headCellClassName = `rankingTable__headCell${
    isDesktop ? " rankingTable__headCell--desktop" : ""
  }`;

  const columns = [
    { id: "position", label: "" },
    { id: "username", label: "Player" },
    { id: "points", label: "Points" },
    { id: "perfectBets", label: isDesktop ? "Perfect Bets" : "PB" },
    { id: "goodBets", label: isDesktop ? "Good Bets" : "GB" },
    { id: "wrongBets", label: isDesktop ? "Wrong Bets" : "WB" },
  ];

  return (
    <Paper
      sx={{ width: "93%", overflowY: "auto", background: palette.bgSurface }}
    >
      <TableContainer>
        <Table stickyHeader aria-label="Loading ranking">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} className={headCellClassName}>
                  {column.label}
                </TableCell>
              ))}
              {isDesktop && (
                <TableCell className={headCellClassName}>Last 5 bets</TableCell>
              )}
              <TableCell className={headCellClassName} align="center">
                Bets
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <TableRow key={`ranking-skeleton-${rowIndex}`}>
                <TableCell>
                  <Skeleton variant="text" width={16} />
                </TableCell>
                <TableCell>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    {isDesktop && (
                      <Skeleton variant="circular" width={32} height={32} />
                    )}
                    <Skeleton variant="text" width={isDesktop ? 140 : 70} />
                  </div>
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={24} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={24} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={24} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={24} />
                </TableCell>
                {isDesktop && (
                  <TableCell>
                    <Skeleton variant="text" width={110} />
                  </TableCell>
                )}
                <TableCell padding="checkbox" align="center">
                  <Skeleton variant="circular" width={24} height={24} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default RankingTableSkeleton;
